<div class="modal-body">
  <p class="text-center">
    {{
      'message.get-reset-password-successful.' + tenant
        | translate
    }}
  </p>
  <div class="d-flex align-items-center justify-content-center py-3">
    <i class="bi bi-check-lg fs-1"></i>
  </div>
</div>
